import { render, staticRenderFns } from "./SearchableTable.vue?vue&type=template&id=1e5066d1"
import script from "./SearchableTable.vue?vue&type=script&lang=ts"
export * from "./SearchableTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports